import React from "react"
import {ReactComponent as EmptyIcon} from "../assets/icons/checkbox/checkbox_empty.svg"
import {ReactComponent as CheckedIcon} from "../assets/icons/checkbox/checkbox_checked.svg"

export default function Checkbox({checked, onChange, disabled = false, ...props}) {
  checked = !!checked
  disabled = !!disabled

  const {className} = props

  const classNames = ["da-checkbox"]
  if (className != null) classNames.push(className)

  const handleOnClick = () => {
    if (disabled || !onChange) {
      return
    }

    onChange(!checked)
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      handleOnClick()
    }
  }

  return (
    <div
      className={classNames.join(" ")}
      role="checkbox"
      tabIndex={disabled ? -1 : 0}
      aria-checked={checked}
      aria-disabled={disabled}
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
    >
      {checked ? <CheckedIcon/> : <EmptyIcon/>}
    </div>
  )
}
